import PropTypes from 'prop-types';
import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { DocumentTitle, PageHeader } from 'components/common';
import ArchiveConfigForm from 'components/ArchiveConfigForm';
import ArchiveLicenseStatusContainer from 'components/ArchiveLicenseStatusContainer';

import DocsHelper from 'util/DocsHelper';
import Routes from 'routing/Routes';

const ArchiveConfigurationPage = React.createClass({
  propTypes: {
    history: PropTypes.object.isRequired,
  },

  render() {
    return (
      <DocumentTitle title="Archives configuration">
        <div>
          <PageHeader title="Edit archives configuration">
            <span>
              The Graylog archive feature allows you to create archives from indices. The generated archives
              are simple flat files that can be moved to cheap storage and re-imported at any time.
            </span>
            <span>
              Archive your old indices automatically by setting your index retention strategy to archive
              on the{' '} <LinkContainer to={Routes.SYSTEM.INDICES.LIST}><a>indices</a></LinkContainer>{' '}
              page.
            </span>
            <span>
              <LinkContainer to={Routes.pluginRoute('SYSTEM_ARCHIVES')}>
                <Button bsStyle="info">Overview</Button>
              </LinkContainer>
              &nbsp;
              <LinkContainer to={Routes.pluginRoute('SYSTEM_ARCHIVES_CONFIGURATION')}>
                  <Button bsStyle="info" className="active">Configuration</Button>
                </LinkContainer>
              &nbsp;
              <LinkContainer to={Routes.pluginRoute('SYSTEM_ARCHIVES_BACKENDS')}>
                  <Button bsStyle="info">Manage Backends</Button>
              </LinkContainer>
            </span>
          </PageHeader>
          <ArchiveLicenseStatusContainer />
          <Row className="content">
            <Col lg={8}>
              <ArchiveConfigForm history={this.props.history} />
            </Col>
          </Row>
        </div>
      </DocumentTitle>
    );
  },
});

export default ArchiveConfigurationPage;



// WEBPACK FOOTER //
// ./src/web/ArchiveConfigurationPage.jsx